import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import {
  Button,
  Menu,
  MenuItem,
  MenuProps,
  Typography,
  styled,
} from "@mui/material";
import { ReactElement, useState } from "react";

import { palette } from "~frontend/theme";

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    marginTop: 0,
    minWidth: 150,
    borderRadius: 0,
    boxShadow: 0,
    "& .MuiMenu-list": {
      padding: "0 0 4px",
      "& :last-child.MuiMenuItem-root": {
        borderBottom: `1px solid ${palette.blue4}`,
      },
    },
    "& .MuiMenuItem-root": {
      border: `1px solid ${palette.blue4}`,
      padding: "10px 0",
      borderBottom: 0,
      minHeight: "unset",
      justifyContent: "center",
      backgroundColor: palette.white,

      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:hover": {
        backgroundColor: palette.lightBlue,
      },
    },
  },
}));

export const DropdownButton = ({
  label,
  width = "150px",
  disabled = false,
  menuItems,
}: {
  label: string;
  width?: string | number;
  disabled?: boolean;
  menuItems: {
    key?: string;
    label: string;
    onClick: () => void;
    disabled?: boolean;
  }[];
}): ReactElement => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant="contained"
        disableElevation
        disabled={disabled}
        onClick={handleClick}
        endIcon={isOpen ? <ArrowDropUp /> : <ArrowDropDown />}
        aria-haspopup="true"
        aria-expanded={isOpen ? "true" : undefined}
        sx={{
          width,
          minWidth: width,
          "& .MuiButton-endIcon": {
            marginLeft: "0px",
          },
        }}
      >
        {label}
      </Button>
      <StyledMenu open={isOpen} onClose={handleClose} anchorEl={anchorEl}>
        {menuItems.map(({ key, label, disabled, onClick }) => (
          <MenuItem
            key={key}
            onClick={() => {
              onClick();
              handleClose();
            }}
            disableRipple
            sx={{ width }}
            disabled={disabled}
          >
            <Typography
              variant="body1"
              sx={{
                fontSize: "12px",
                fontWeight: 400,
                lineHeight: "14.4px",
                textAlign: "center",
                textWrap: "wrap",
                width: "100%",
                padding: "0 16px",
              }}
            >
              {label}
            </Typography>
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  );
};
